import { ScheduleItem } from '@/types';
import { Game, TeamEvent } from './types/games_api_types';

export function populateScheduleItemDayTime({
  scheduleItem,
}: {
  scheduleItem: ScheduleItem;
}) {
  if (scheduleItem.type === 'event' && scheduleItem.end_time !== null) {
    scheduleItem.day_string =
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        month: 'short',
        day: 'numeric',
      })
        .format(new Date(scheduleItem.start_time * 1000))
        .replace(/ /g, '\xa0') +
      ' - ' +
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        month: 'short',
        day: 'numeric',
      })
        .format(new Date(scheduleItem.end_time * 1000))
        .replace(/ /g, '\xa0');
  } else if (scheduleItem.time_tba) {
    scheduleItem.day_string = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      month: 'short',
      day: 'numeric',
    })
      .format(new Date(scheduleItem.start_time * 1000))
      .replace(/ /g, '\xa0');
    scheduleItem.time_string = 'TBA';
  } else {
    scheduleItem.day_string = new Intl.DateTimeFormat('en-US', {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      month: 'short',
      day: 'numeric',
    })
      .format(new Date(scheduleItem.start_time * 1000))
      .replace(/ /g, '\xa0');
    scheduleItem.time_string = new Intl.DateTimeFormat('en-US', {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      hour: 'numeric',
      minute: '2-digit',
    })
      .format(new Date(scheduleItem.start_time * 1000))
      .replace(/ /g, '\xa0');
  }

  if (scheduleItem.postponed) {
    scheduleItem.time_string = '';
    scheduleItem.tv_channel = 'Postponed';
  }

  return scheduleItem;
}

export function scheduleItemTimeString(scheduleItem: Game | TeamEvent) {
  let timeString = scheduleItem.time_tba
    ? 'TBA'
    : timeToTimeString({ time: scheduleItem.start_time });

  if ('home_team' in scheduleItem) {
    if (scheduleItem.postponed) {
      return '';
    }

    if (scheduleItem.state === 'in_progress') {
      return scheduleItem.status_text;
    }

    if (scheduleItem.state === 'finished') {
      return 'FINAL';
    }
  }

  return timeString;
}

export function timeToDayString({ time }: { time: number }) {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
    .format(new Date(time * 1000))
    .replace(/ /g, '\xa0');
}

export function timeToTimeString({ time }: { time: number }) {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour: 'numeric',
    minute: '2-digit',
  })
    .format(new Date(time * 1000))
    .replace(/ /g, '\xa0');
}
